interface PieChartLabelOptions {
  typeOfExternalLabel?: "value" | "text" | "text_and_value";
  typeLabelText?: "value" | "percent";
  externalLabelSize?: number;
  externalLabelWeight?: string;
  externalLabelColor?: string;
  externalValueSize?: number;
  externalValueWeight?: string;
  externalValueColor?: string;
  category?: string;
  formatedValue?: string | number;
}

export const getPieChartLabelFormat = (options: PieChartLabelOptions): string => {
  const {
    typeOfExternalLabel,
    typeLabelText,
    externalLabelSize = 1,
    externalLabelWeight = "normal",
    externalLabelColor = "#000",
    externalValueSize = 1,
    externalValueWeight = "normal",
    externalValueColor = "#000",
    category,
    formatedValue,
  } = options;

  const defaultCategoryLabelStyle = `[font-size: ${externalLabelSize}rem ${externalLabelWeight} ${externalLabelColor}]`;
  const defaultValueLabelStyle = `[font-size: ${externalValueSize / 1.15}rem ${externalValueColor} ${externalValueWeight}]`;

  if (typeOfExternalLabel === "value" && typeLabelText === "value") {
    const valueStyle = `[font-size: ${externalValueSize}rem ${externalLabelWeight} ${externalValueColor}]`;
    return `${valueStyle}${formatedValue}[/]`;
  } else if (typeOfExternalLabel === "value") {
    const valueStyle = `[font-size: ${externalValueSize}rem ${externalLabelWeight} ${externalValueColor}]`;
    const percentStyle = `[font-size:${externalValueSize / 1.5}rem]`;
    return `${valueStyle}${formatedValue}[/]${percentStyle}%[/]`;
  } else if (typeOfExternalLabel === "text") {
    return `${defaultCategoryLabelStyle}${category}[/]`;
  } else if (typeOfExternalLabel === "text_and_value" && typeLabelText === "value") {
    return `${defaultCategoryLabelStyle}${category}[/]\n${defaultValueLabelStyle}${formatedValue}[/]`;
  } else if (typeOfExternalLabel === "text_and_value") {
    const percentStyle = `[font-size:${externalLabelSize / 1.5}rem ${externalValueColor} ${externalValueWeight}]`;
    return `${defaultCategoryLabelStyle}${category}[/]\n${defaultValueLabelStyle}${formatedValue}[/]${percentStyle}%[/]`;
  } else if (typeLabelText === "value") {
    return `${defaultValueLabelStyle}${formatedValue}[/]\n${defaultCategoryLabelStyle}${category}[/]`;
  }

  const percentStyle = `[font-size:${externalValueSize / 1.5}rem ${externalValueColor} ${externalValueWeight}]`;
  return `${defaultValueLabelStyle}${formatedValue}[/]${percentStyle}%[/]\n${defaultCategoryLabelStyle}${category}[/]`;
};
